import { render, staticRenderFns } from "./Process-6.vue?vue&type=template&id=10dfc1f9&scoped=true&"
import script from "./Process-6.vue?vue&type=script&lang=js&"
export * from "./Process-6.vue?vue&type=script&lang=js&"
import style0 from "./Process-6.vue?vue&type=style&index=0&id=10dfc1f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10dfc1f9",
  null
  
)

export default component.exports